import React from 'react';
import TextFieldEngine from './TextFieldEngine';

const ParagraphFieldEngine = ({
  internalId,
  value,
  setValue,
  required,
  readOnly,
  ...fieldProps
}) => {
  const viewProps = {
    internalId,
    value,
    setValue,
    required,
    readOnly,
    muiInputProps: {
      multiline: true,
      rows: 3,
      rowsMax: 15,
      customCSS: 'textarea {padding: 0.1rem; font-size: 14px; resize: vertical;}'
    },
    ...fieldProps
  };

  return <TextFieldEngine {...viewProps} />;
};

export default ParagraphFieldEngine;
